var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "box-card" },
    [
      _c(
        "div",
        { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
        [_c("span", [_vm._v(_vm._s(_vm.$t("basicData.annex")))])]
      ),
      _c("UploadCmp", {
        ref: "uploadRef",
        attrs: {
          drag: false,
          multiple: false,
          "auto-upload": true,
          limit: 10,
          "file-size": 10,
          tips: _vm.tips,
          "show-file-list": false,
          "file-type": [
            "image/png",
            "image/jpeg",
            "image/bmp",
            "application/pdf",
          ],
          "is-check-file-type": true,
          "upload-text": _vm.$t("spareNumberPoo.SelectTheFile"),
        },
        on: { change: _vm.onFileChange },
      }),
      _c("div", { staticClass: "file-list" }, [
        _c(
          "ul",
          { staticClass: "el-upload-list el-upload-list--text" },
          _vm._l(_vm.fileData, function (item, index) {
            return _c(
              "li",
              { key: index, staticClass: "el-upload-list__item feet-r" },
              [
                _c("el-link", { attrs: { target: "_blank", href: item.url } }, [
                  _c("i", { staticClass: "el-icon-document" }),
                  _vm._v(" " + _vm._s(item.name) + " "),
                ]),
                _c("div", [
                  _c("span", {
                    staticClass: "el-icon-download addStyle",
                    on: {
                      click: function ($event) {
                        return _vm.downloadFile(item, index)
                      },
                    },
                  }),
                  _c("span", {
                    staticClass: "el-icon-delete deleteStyle",
                    on: {
                      click: function ($event) {
                        return _vm.handleRemove(item, index)
                      },
                    },
                  }),
                ]),
              ],
              1
            )
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }